import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

/** "Customers · Sahab ERP" — the window title follows the page and the language. */
export function useDocumentTitle(title: string | undefined): void {
  const { t } = useTranslation()
  const appName = t('appName')
  useEffect(() => {
    document.title = title ? `${title} · ${appName}` : appName
  }, [title, appName])
}
